(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[883],{

/***/ 9497:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage",
      function () {
        return __webpack_require__(8540);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _loadable = _interopRequireDefault(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { useSyncExternalStore  } =  true ? __webpack_require__(7294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ AnimationContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2188);
/* harmony import */ var _AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const animationName = "fade-in-up";
const AnimationContainer = (props)=>{
    const { children , ...restProps } = props;
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: animationCSS , 1: setAnimationCSS  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((_AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().animationContainer));
    const { 0: animationState , 1: setAnimationState  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("waiting");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (containerRef.current === null) {
            return;
        }
        const containerElement = containerRef.current;
        const buildThresholdList = ()=>{
            const thresholds = [];
            const numSteps = 20;
            for(let i = 1.0; i <= numSteps; i += 1){
                const ratio = i / numSteps;
                thresholds.push(ratio);
            }
            thresholds.push(0);
            return thresholds;
        };
        const handleIntersect = (entries, observer)=>{
            entries.forEach((entry)=>{
                if (animationState === "finished") {
                    observer.disconnect();
                }
                if (animationState === "waiting" && entry.intersectionRatio > 0.5) {
                    containerElement.classList.add(animationName);
                    setAnimationCSS(`${(_AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().animationContainer)} ${(_AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().animation)}`);
                    setAnimationState("finished");
                    window.dataLayer.push({
                        event: "animationPlayed",
                        page: "/",
                        path: "/"
                    });
                }
            });
        };
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: buildThresholdList()
        };
        const observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(containerElement);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: containerRef,
        className: animationCSS,
        ...restProps,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_AnimationContainer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().animationContainerChildren),
            children: children
        })
    });
};



/***/ }),

/***/ 1489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ExploreCompanies": function() { return /* binding */ ExploreCompanies; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(5824);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/Homepage/CompanyCard.module.scss
var CompanyCard_module = __webpack_require__(5264);
var CompanyCard_module_default = /*#__PURE__*/__webpack_require__.n(CompanyCard_module);
;// CONCATENATED MODULE: ./src/Homepage/CompanyCard.tsx






/**
 * Renders a company card component.
 */ const CompanyCard = (props)=>{
    const { index , company , featureHeading , lazy  } = props;
    const { shortName ="" , description ="" , primaryImage ="" , title ="" , slug ="" , legacyId ="0" , id =0 , logoImage =""  } = company;
    const { publicRuntimeConfig: { staticAssetHost , pilboxHost , museHost  }  } = (0,config["default"])();
    const eventProps = {
        content_type: "module",
        company_name: title,
        company_short_name: slug,
        company_id: legacyId?.toString() ?? null,
        company_craft_id: id,
        placement_position: index,
        sp_content_is_tile: true,
        sp_tile_entity_id: legacyId?.toString() ?? null,
        sp_tile_order: index,
        sp_tile_type: "profile",
        sp_tile_company_id: legacyId?.toString() ?? null,
        sp_impression_component: "tile",
        sp_impression_position: "main",
        sp_impression_tile_type: "profile",
        sp_page_section: "homepage",
        sp_click_component: "tile",
        sp_click_button_type: null,
        sp_click_component_tile_type: "profile",
        sp_click_button_text: null,
        sp_click_position: "main",
        sp_click_target_page_section: "profile",
        sp_tile_location: featureHeading
    };
    const trackingProps = JSON.stringify(eventProps);
    const heroWidth = {
        xs: 327,
        sm: 336,
        md: 288,
        lg: 376
    };
    const profileUrl = `${museHost}/profiles/${shortName}`;
    const jobsUrl = `${museHost}/search/company/${shortName}`;
    const pilboxPath = `${pilboxHost}/image.jpg?filter=antialias&opt=1&pos=top-left&prog=1&q=keep&url=`;
    const backupHero = "https://assets.themuse.com/images/missing-company-hero.jpg";
    const { 0: heroSrc , 1: setHeroSrc  } = (0,react.useState)(primaryImage ? `${staticAssetHost}/${primaryImage}` : backupHero);
    const heroOnError = ()=>setHeroSrc(backupHero);
    // eslint-disable-next-line max-len
    const logoBackupSrc = "data:image/svg+xml,<svg height='37' width='29' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 29 37' ><g stroke='%23767676'><path d='M28.5 35.028a1 1 0 0 1-1 1h-13V1.972a1 1 0 0 1 1.582-.814l12 8.572a1 1 0 0 1 .418.814v24.484ZM26.5 8.6V3.028m-12 7h4m-4 6h6m-20 6h6m-6 6h6m8-6h9'></path><path d='M18.5 36.028v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7m-10-20h-13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h13'></path></g></svg>";
    const { 0: logoSrc , 1: setLogoSrc  } = (0,react.useState)(logoImage ? `${staticAssetHost}/${logoImage}` : logoBackupSrc);
    const logoOnError = ()=>setLogoSrc(logoBackupSrc);
    /**
     * Returns a callback function for a button click event.
     */ const getButtonCallBack = (btnProps)=>(event)=>{
            const { type , text , target  } = btnProps;
            event.preventDefault();
            (0,build.triggerSnowplowClickEvent)({
                ...eventProps,
                sp_click_component: "tile",
                sp_click_insert_type: null,
                sp_click_button_type: type,
                sp_click_link_text: null,
                sp_click_button_text: text,
                sp_click_target_page_section: target,
                sp_click_search_id: null
            });
            window.location.href = target === "profile" ? profileUrl : jobsUrl;
            return false;
        };
    /**
     * Returns a callback function for a button click event.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getImageCallBack = ()=>(_)=>{
            (0,build.triggerSnowplowClickEvent)({
                ...eventProps,
                sp_click_component: "tile",
                sp_click_insert_type: null,
                sp_click_button_type: "profile",
                sp_click_link_text: "<image>",
                sp_click_button_text: null,
                sp_click_target_page_section: "profile",
                sp_click_search_id: null
            });
            window.location.href = profileUrl;
        };
    const profileBtnCB = getButtonCallBack({
        type: "profile",
        text: "VIEW PROFILE",
        target: "profile"
    });
    const searchBtnCB = getButtonCallBack({
        type: "job_search",
        text: "VIEW JOBS",
        target: "search"
    });
    const imageCB = getImageCallBack();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (CompanyCard_module_default()).companyCard,
        "data-tracking-props": trackingProps,
        "data-tracking-event-type": "impression",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompanyCard_module_default()).header,
                "aria-hidden": "true",
                onClick: ()=>imageCB(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        className: (CompanyCard_module_default()).hero,
                        src: `${pilboxPath}${heroSrc}&w=${heroWidth.xs}`,
                        srcSet: `
                        ${pilboxPath}${heroSrc}&w=${heroWidth.xs} ${heroWidth.xs}w,
                        ${pilboxPath}${heroSrc}&w=${heroWidth.sm} ${heroWidth.sm}w,
                        ${pilboxPath}${heroSrc}&w=${heroWidth.md} ${heroWidth.md}w,
                        ${pilboxPath}${heroSrc}&w=${heroWidth.lg} ${heroWidth.lg}w
                    `,
                        loading: lazy ? "lazy" : "eager",
                        sizes: `(max-width: ${heroWidth.lg}px) ${heroWidth.xs}px, ${heroWidth.sm}px, ${heroWidth.md}px, ${heroWidth.lg}px`,
                        width: "327",
                        height: "218",
                        "data-tracking-event-type": "click",
                        onError: heroOnError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (CompanyCard_module_default()).logo,
                        src: logoSrc,
                        width: "80",
                        height: "80",
                        alt: "",
                        onError: logoOnError,
                        loading: lazy ? "lazy" : "eager"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompanyCard_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (CompanyCard_module_default()).name,
                        children: title ?? ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (CompanyCard_module_default()).description,
                        children: description?.replace(/<[^>]*>/g, "") ?? ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                        className: (CompanyCard_module_default()).footer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                className: (CompanyCard_module_default()).search,
                                color: "white",
                                href: jobsUrl,
                                onClick: (e)=>searchBtnCB(e),
                                children: "view jobs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                                className: (CompanyCard_module_default()).profile,
                                color: "secondary-100",
                                href: profileUrl,
                                onClick: (e)=>profileBtnCB(e),
                                children: "view profile"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ./src/Homepage/ExploreCompanies.module.scss
var ExploreCompanies_module = __webpack_require__(5579);
var ExploreCompanies_module_default = /*#__PURE__*/__webpack_require__.n(ExploreCompanies_module);
;// CONCATENATED MODULE: ./src/Homepage/ExploreCompanies.tsx




/**
 * Renders a section displaying a list of featured companies.
 */ const ExploreCompanies = (props)=>{
    const { featureHeading ="" , companies =[] , exploreCompaniesSubheading ="" , heading ="" ,  } = props;
    const liveCompanies = companies.filter((company)=>company.status === "live");
    if (!liveCompanies.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ExploreCompanies_module_default()).section,
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (ExploreCompanies_module_default()).heading,
                children: heading
            }),
            exploreCompaniesSubheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ExploreCompanies_module_default()).subheading,
                children: exploreCompaniesSubheading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ExploreCompanies_module_default()).grid,
                children: [
                    featureHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ExploreCompanies_module_default()).sectionTitle,
                        children: featureHeading
                    }),
                    liveCompanies.map((company, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCard, {
                            company: company,
                            index: index + 1,
                            featureHeading: featureHeading,
                            lazy: index > 0
                        }, company.title))
                ]
            })
        ]
    });
};



/***/ }),

/***/ 4301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MediaVine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3863);




// All the ad types/positions there are.
const allAds = [
    "leaderboard",
    "sidebar-atf",
    "sidebar-btf",
    "content-desktop",
    "content-mobile",
    "adhesion-mobile",
    "adhesion-tablet",
    "adhesion-desktop",
    "recipe",
    "auto-insert-sticky",
    "in-image",
    "chicory",
    "zergnet",
    "interstitial-mobile",
    "interstitial-desktop",
    "universal-player-desktop",
    "universal-player-mobile"
];
/**
 * Renders MediaVine ads based on the allowList provided.
 * If the URL parameter '?hide-ads' is present, ads will not be displayed.
 * if there are no members of allowList, ads will not be displayed
 *
 * @param props - Object containing the allowList array.
 * @returns JSX element with MediaVine ads or null if ads are not to be displayed.
 */ const MediaVine = (props)=>{
    const { allowList =[]  } = props;
    const { pageMetaData: { pathName  }  } = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppState */ .mr)();
    // Remove items that should be allowed from the blockList.
    const blockList = allAds.filter((adType)=>!allowList.includes(adType));
    // Convert the list into a set of data attributes.
    const blockAttributes = blockList.reduce((obj, item)=>({
            ...obj,
            [`data-blocklist-${item}`]: "1"
        }), {});
    // Do not show ads if we have the query string
    // Do not show ads if we have no allowed slots.
    return !pathName.includes("hide-ads") && !!allowList.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "mediavine",
                strategy: "lazyOnload",
                "data-noptimize": "1",
                "data-cfasync": "false",
                src: "//scripts.mediavine.com/tags/the-muse.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "mediavine-settings",
                ...blockAttributes
            })
        ]
    }) : null;
};


/***/ }),

/***/ 7155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ AppPageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _themuse_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9551);
/* harmony import */ var hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3863);

/* eslint-disable camelcase */ 


const AppPageLayout = (props)=>{
    const { children , ...restProps } = props;
    const { user  } = (0,hooks_AppContext__WEBPACK_IMPORTED_MODULE_2__/* .useAppState */ .mr)();
    const pageProps = {
        ...restProps,
        user
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_themuse_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...pageProps,
        children: children
    });
};


/***/ }),

/***/ 65:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagsProvider; },
  "n": function() { return /* binding */ useFeatureFlagsState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts


/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ const isFeatureFlagActive = (name, query, config)=>{
    if (name in query) {
        return isTruthy(query[name]);
    }
    if (config?.[name] !== undefined) {
        return config?.[name] === true || config?.[name] === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ const getFeatureFlags = ()=>{
    const { publicRuntimeConfig  } = (0,config["default"])();
    return Object.keys(publicRuntimeConfig).reduce((prev, curr)=>{
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ const getActiveFeatureFlags = (context)=>{
    const { query  } = context;
    const { publicRuntimeConfig  } = getConfig();
    const featureFlagsInQuery = getFeatureFlags().reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag]: isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)
        }), {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx



const defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce((featureFlags, featureFlag)=>({
        ...featureFlags,
        [featureFlag]: false
    }), {});
const FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
const FeatureFlagsProvider = (props)=>{
    const { featureFlags , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
const useFeatureFlagsState = ()=>{
    const context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";



/***/ }),

/***/ 8540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ homepage; },
  "formatCompanySuggestions": function() { return /* binding */ homepage_formatCompanySuggestions; },
  "updateInput": function() { return /* binding */ homepage_updateInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/hooks/useSessionStorage/useSessionStorage.tsx + 1 modules
var useSessionStorage = __webpack_require__(5310);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
// EXTERNAL MODULE: ./src/utils/api.ts + 4 modules
var api = __webpack_require__(8388);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 4 modules
var AppContext = __webpack_require__(3863);
// EXTERNAL MODULE: ./src/hooks/FeatureFlagsContext.tsx + 1 modules
var FeatureFlagsContext = __webpack_require__(65);
// EXTERNAL MODULE: ./src/components/AppPageLayout.tsx
var AppPageLayout = __webpack_require__(7155);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(3197);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(5824);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/Homepage/ExploreCompanies.tsx + 1 modules
var ExploreCompanies = __webpack_require__(1489);
// EXTERNAL MODULE: ./src/Homepage/AnimationContainer.tsx
var AnimationContainer = __webpack_require__(551);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableHeaderDropdown.tsx + 1 modules
var ComposableHeaderDropdown = __webpack_require__(5117);
// EXTERNAL MODULE: ./src/Homepage/SearchDropdown.module.scss
var SearchDropdown_module = __webpack_require__(5572);
var SearchDropdown_module_default = /*#__PURE__*/__webpack_require__.n(SearchDropdown_module);
;// CONCATENATED MODULE: ./src/Homepage/SearchDropdown.tsx








const pushDataLayerEvent = (event, props = {})=>{
    if ((0,browser/* isBrowser */.jU)() && window.dataLayer) {
        window.dataLayer.push({
            event,
            ...props
        });
    }
};
const formatCompanySuggestions = (companySuggestions)=>companySuggestions.slice(0, 4).map((companyResult)=>{
        const { text , value  } = companyResult;
        // eslint-disable-next-line camelcase
        const { short_name  } = value;
        return {
            label: `${text}`,
            // eslint-disable-next-line camelcase
            value: `/profiles/${short_name}?_search_id=${esm_browser_v4()}`
        };
    });
const updateInput = async (changes, setItems, setInputValue, fetchData)=>{
    const { inputValue  } = changes;
    const jobSearchItem = {
        label: `${inputValue}`,
        value: `/search/keyword/${inputValue}/?_search_id=${esm_browser_v4()}`
    };
    setInputValue(inputValue);
    if (inputValue) {
        setItems([
            jobSearchItem
        ]);
        const companyResults = await fetchData("", inputValue);
        const companyList = companyResults?.length ? formatCompanySuggestions(companyResults) : [];
        setItems([
            jobSearchItem
        ].concat(companyList));
    } else {
        setItems([]);
    }
};
const SearchDropdown = ()=>{
    const { 0: dropdownItems , 1: setDropdownItems  } = (0,react.useState)([]);
    const { 0: inputValue , 1: setInputValue  } = (0,react.useState)("");
    const snowplowSearchEvent = (selectedItem)=>{
        const searchType = selectedItem?.value.startsWith("/profiles/") ? "company" : "job";
        // Note: Using location.origin because museApiOptions is not populated on error pages.
        const parsedUrl = new URL(selectedItem?.value || "", window.location.origin);
        const searchId = parsedUrl.searchParams.get("_search_id") || esm_browser_v4();
        const eventProps = {
            sp_search_type: searchType,
            sp_search_id: searchId,
            sp_search_keyword: selectedItem?.label
        };
        (0,build.triggerSnowplowSearchEvent)(eventProps);
    };
    const searchQuerySubmittedEvent = (selectedItemText)=>{
        const searchTerm = selectedItemText || inputValue;
        const eventProps = {
            search_term: searchTerm || ""
        };
        pushDataLayerEvent("searchQuerySubmitted", eventProps);
    };
    const onKeyboardSelectItem = (_, selectedItem)=>{
        if (!(0,browser/* isBrowser */.jU)()) return "";
        const searchPath = inputValue ? `/search/keyword/${inputValue}` : "/search";
        const path = selectedItem?.value ? selectedItem?.value : `${searchPath}?_search_id=${esm_browser_v4()}`;
        searchQuerySubmittedEvent(selectedItem?.label);
        if (selectedItem?.value) {
            snowplowSearchEvent(selectedItem);
        } else {
            snowplowSearchEvent({
                label: inputValue,
                value: path
            });
        }
        return window.open(path, "_blank").focus();
    };
    const onMouseSelectItem = (_, selectedItem)=>{
        searchQuerySubmittedEvent(selectedItem.label);
        snowplowSearchEvent(selectedItem);
    };
    const homepageClasses = {
        container: (SearchDropdown_module_default()).container,
        containerOpened: (SearchDropdown_module_default()).containerOpened,
        inputContainer: (SearchDropdown_module_default()).inputContainer,
        inputContainerOpened: (SearchDropdown_module_default()).inputContainerOpened,
        input: (SearchDropdown_module_default()).input,
        menuOpened: (SearchDropdown_module_default()).menuOpened,
        menuList: (SearchDropdown_module_default()).menuList,
        listItem: (SearchDropdown_module_default()).listItem,
        listItemText: (SearchDropdown_module_default()).listItemText,
        inputClearButton: (SearchDropdown_module_default()).inputClearButton,
        closeButton: (SearchDropdown_module_default()).closeButton,
        postLabel: (SearchDropdown_module_default()).postLabel
    };
    const dropdownProps = {
        classes: homepageClasses,
        dropdownProps: {
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
            }),
            debounceWait: 10,
            dropdownList: dropdownItems,
            inputId: "search-input",
            onInputChange: (changes)=>updateInput(changes, setDropdownItems, setInputValue, api/* fetchHomepageCompanySuggestions */.b5),
            noResultsMessage: " ",
            onKeyboardSelectItem,
            onMouseSelectItem
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableHeaderDropdown/* default */.Z, {
        ...dropdownProps
    });
};

// EXTERNAL MODULE: ./src/Homepage/HomepageHeader.module.scss
var HomepageHeader_module = __webpack_require__(4020);
var HomepageHeader_module_default = /*#__PURE__*/__webpack_require__.n(HomepageHeader_module);
;// CONCATENATED MODULE: ./src/Homepage/HomepageHeader.tsx

/* eslint-disable max-len */ 




const baseHeroImage = "https://advice-assets.themuse.com/advice-static/images/homepage-hero-image.jpg";
const getHeroImage = (height, width)=>{
    const { publicRuntimeConfig: { pilboxHost  }  } = (0,config["default"])();
    const flags = "filter=antialias&mode=crop&opt=1&pos=center&prog=1&q=keep";
    const result = `${pilboxHost}/image.png?${flags}&url=${baseHeroImage}&h=${height}&w=${width}`;
    return result;
};
const HomepageHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomepageHeader_module_default()).headerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomepageHeader_module_default()).left,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimationContainer/* AnimationContainer */.B, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: (HomepageHeader_module_default()).h1,
                                    children: [
                                        "Find work",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " ",
                                        "that's",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "worth it."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (HomepageHeader_module_default()).subtext,
                                    children: "Make a career match where the people, perks and values align with your needs."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDropdown, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomepageHeader_module_default()).right,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HomepageHeader_module_default()).images,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomepageHeader_module_default()).stars
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "",
                            className: (HomepageHeader_module_default()).hero,
                            src: "https://advice-assets.themuse.com/advice-static/images/homepage-hero-image.jpg",
                            srcSet: `${getHeroImage(200, 133)} 375w, ${getHeroImage(364, 301)} 768w, ${baseHeroImage} 1024w`
                        })
                    ]
                })
            })
        ]
    });


// EXTERNAL MODULE: ./src/components/MayaBanner/MayaCard.module.scss
var MayaCard_module = __webpack_require__(2909);
var MayaCard_module_default = /*#__PURE__*/__webpack_require__.n(MayaCard_module);
;// CONCATENATED MODULE: ./src/components/MayaBanner/MayaCard.tsx




const MayaCard = ()=>{
    const { FEATURE_FLAG_HOMEPAGE_MAYA_BANNER  } = (0,FeatureFlagsContext/* useFeatureFlagsState */.n)();
    if (!FEATURE_FLAG_HOMEPAGE_MAYA_BANNER) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: (MayaCard_module_default()).mayaPromo,
        "aria-label": "Maya AI Assistant Promotion",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MayaCard_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.themuse.com/maya",
                        className: (MayaCard_module_default()).logo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 171 131",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#1D2D5A",
                                    d: "M46.03 111.679c2.071-.443 4.29-1.405 4.29-6.436V88.525c0-4.587-2.885-6.51-6.214-6.51-1.997 0-3.994.814-5.918 2.441.148.814.222 1.702.222 2.59v18.197c0 5.031 2.146 5.993 4.29 6.436v1.11H23.69v-1.11c2.144-.443 4.29-1.405 4.29-6.436V88.525c0-4.66-2.811-6.51-6.214-6.51-1.998 0-3.921.814-5.696 2.367v20.861c0 5.031 2.219 5.993 4.364 6.436v1.11H.387v-1.11c2.515-.443 5.178-1.405 5.178-6.436V83.051c0-5.03-2.663-5.992-5.178-6.436v-1.11H16.07v6.88c2.515-4.217 6.288-7.324 11.54-7.324 4.956 0 8.95 2.663 10.357 7.916 2.515-4.513 6.435-7.916 11.836-7.916 6.066 0 10.948 4.069 10.948 11.984v18.198c0 5.031 2.737 5.993 5.105 6.436v1.11H46.03v-1.11Zm29.898 1.776c-6.066 0-10.652-4.291-10.652-10.209 0-7.99 7.99-13.168 20.343-11.022v-4.439c0-5.03-3.699-7.25-7.767-7.25-3.33 0-7.324 1.406-10.357 5.919l-1.11-.296c1.628-5.549 7.102-10.949 15.461-11.097 8.582-.148 14.352 5.326 14.352 12.428v16.941c0 1.849.296 3.551 1.627 3.551.222 0 .74-.074 1.11-.222l.518.444c-1.036 2.589-3.625 5.252-7.398 5.252-3.477 0-5.844-2.219-6.362-5.178-1.997 2.811-5.252 5.178-9.765 5.178Zm-.74-11.54c0 3.55 1.628 6.805 5.253 6.805 2.145 0 3.995-1.257 5.178-2.811V94.221c-6.436-.666-10.43 2.367-10.43 7.694Zm22.63 24.338 1.331-8.064.962-.591c6.436 3.994 12.724 2.441 14.425-1.776l.148-.444-13.389-32.771c-1.924-4.735-3.995-5.548-5.697-5.992v-1.11h19.974v1.11c-2.811.592-4.66 1.701-2.959 6.066l7.546 19.16 7.693-19.234c1.849-4.513-.74-5.548-3.477-5.992v-1.11h12.724v1.11c-1.923.444-4.365 1.331-6.214 5.992l-14.129 34.473c-4.291 10.504-10.283 13.463-18.938 9.173Zm47.03-12.798c-6.067 0-10.653-4.291-10.653-10.209 0-7.99 7.989-13.168 20.343-11.022v-4.439c0-5.03-3.698-7.25-7.767-7.25-3.329 0-7.324 1.406-10.357 5.919l-1.109-.296c1.627-5.549 7.101-10.949 15.461-11.097 8.581-.148 14.351 5.326 14.351 12.428v16.941c0 1.849.296 3.551 1.627 3.551.222 0 .74-.074 1.11-.222l.518.444c-1.036 2.589-3.625 5.252-7.398 5.252-3.477 0-5.844-2.219-6.362-5.178-1.997 2.811-5.252 5.178-9.764 5.178Zm-.74-11.54c0 3.55 1.627 6.805 5.252 6.805 2.145 0 3.995-1.257 5.178-2.811V94.221c-6.436-.666-10.43 2.367-10.43 7.694ZM77.886 35.244V22.742h-2.882v-.658a14.516 14.516 0 0 0 7.824-6.673h.823v5.85h5.356v1.48h-5.356v12.03c0 2.06.829 3.625 2.553 3.625a3.784 3.784 0 0 0 2.56-1.072l.493.164c-1.072 2.224-2.889 4.198-6.014 4.198-3.382-.204-5.356-2.493-5.356-6.442Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#1D2D5A",
                                    d: "M91.481 37.034V16.852c0-2.717-1.487-2.967-2.888-2.967l-.08-.573 8.647-1.48v12.93a6.908 6.908 0 0 1 6.179-3.79c3.218 0 6.264 2.145 6.264 6.429v9.719c0 2.717 1.481 3.21 2.718 3.46v.573h-10.792v-.572c1.073-.25 2.304-.744 2.304-3.461v-8.982c0-2.554-1.481-3.54-3.126-3.626a5.264 5.264 0 0 0-3.547 1.401v11.121c0 2.718 1.316 3.211 2.553 3.461v.58H88.665v-.567c1.316-.263 2.816-.756 2.816-3.474Zm20.676-5.85c0-6.422 3.79-10.212 9.39-10.212 6.179 0 8.811 4.777 8.732 9.719h-12.194c.251 5.356 2.883 7.666 5.923 7.666a7.66 7.66 0 0 0 5.685-2.889l.494.086a9.08 9.08 0 0 1-8.482 5.922c-4.607.006-9.548-3.37-9.548-10.292Zm12.502-1.724c0-3.053-.829-7.238-3.132-7.238s-3.29 4.448-3.376 7.238h6.508Zm-23.051 30.066v-8.983c0-2.467-1.559-3.454-3.29-3.454a4.5 4.5 0 0 0-3.132 1.316c.068.464.095.933.08 1.401v9.72c0 2.717 1.157 3.21 2.309 3.46v.573H87.44v-.572c1.152-.25 2.31-.744 2.31-3.461v-8.897c0-2.474-1.487-3.461-3.29-3.461a4.606 4.606 0 0 0-3.06 1.237v11.12c0 2.718 1.151 3.212 2.303 3.462v.572H74.998v-.572c1.401-.25 2.796-.744 2.796-3.461v-11.78c0-2.717-1.395-3.217-2.796-3.381v-.566H83.4v3.704c1.401-2.224 3.376-3.869 6.179-3.869a5.409 5.409 0 0 1 5.514 4.198c1.402-2.388 3.382-4.198 6.343-4.198 3.218 0 5.85 2.139 5.85 6.422v9.72c0 2.724 1.487 3.217 2.718 3.46v.58H99.476v-.58c.981-.5 2.132-1.012 2.132-3.71Zm8.489-2.146v-9.719c0-2.718-1.487-3.211-2.803-3.376v-.579h8.488v12.937c0 2.553 1.481 3.54 3.126 3.626a5.476 5.476 0 0 0 3.626-1.487V47.747c0-2.718-1.237-3.218-2.303-3.383V43.8h8.067v15.898c0 2.717 1.487 3.21 2.724 3.46v.573h-6.823a9.676 9.676 0 0 1-1.567-3.375 7.782 7.782 0 0 1-6.343 3.625c-3.224-.17-6.192-2.316-6.192-6.6Zm21.662 4.949v-5.771h.658c2.31 4.698 4.534 6.1 6.844 6.1 1.974 0 2.961-1.073 2.961-2.553 0-2.396-2.718-3.054-5.685-4.37-3.541-1.566-5.265-3.375-5.265-6.093 0-3.626 2.882-6.179 7.745-6.179 2.259.08 4.486.554 6.581 1.402v5.35h-.658c-1.81-4.528-3.949-5.436-5.85-5.436-2.053 0-3.29 1.073-3.29 2.474 0 2.06 2.882 2.632 6.507 4.449 2.139.901 4.528 2.303 4.528 5.764 0 4.12-3.126 6.422-7.574 6.422a19.427 19.427 0 0 1-7.502-1.56Zm16.787-8.66c0-6.422 3.79-10.213 9.39-10.213 6.099 0 8.817 4.778 8.732 9.72h-12.2c.25 5.356 2.889 7.659 5.922 7.659a7.65 7.65 0 0 0 5.685-2.882l.494.085a9.085 9.085 0 0 1-8.489 5.923c-4.652.013-9.534-3.363-9.534-10.292Zm12.436-1.73c0-3.047-.822-7.239-3.125-7.239s-3.291 4.455-3.383 7.238h6.508Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#9ADBF5",
                                    d: "M34.25 46.09v-.545A34.2 34.2 0 0 0 3.128 11.459 2.862 2.862 0 0 0 0 14.009v46.766a2.916 2.916 0 0 0 2.884 2.878h31.365V46.09Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#1D2D5A",
                                    d: "M34.25 46.09v-.545a34.2 34.2 0 0 1 31.12-34.086 2.889 2.889 0 0 1 3.129 2.726v46.683a2.91 2.91 0 0 1-2.878 2.878H34.249V46.09Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#4753A4",
                                    d: "m66.022 7.3 2.03-.61a4.407 4.407 0 0 0 2.943-2.944l.61-2.03c.123-.405.702-.405.824 0l.61 2.03a4.407 4.407 0 0 0 2.944 2.943l2.03.61c.405.123.405.702 0 .824l-2.03.611a4.407 4.407 0 0 0-2.943 2.944l-.611 2.029c-.122.406-.701.406-.824 0l-.61-2.03a4.407 4.407 0 0 0-2.944-2.943l-2.03-.61c-.405-.123-.405-.702 0-.824Zm-7.074-3.637 1.032-.312a3.072 3.072 0 0 0 2.053-2.053l.311-1.032c.107-.355.607-.355.718 0l.31 1.032a3.072 3.072 0 0 0 2.054 2.053l1.032.312c.355.106.355.606 0 .717l-1.032.311a3.072 3.072 0 0 0-2.053 2.053l-.311 1.032c-.107.355-.607.355-.718 0l-.31-1.032A3.072 3.072 0 0 0 59.98 4.69l-1.032-.311c-.355-.107-.355-.607 0-.717Z"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MayaCard_module_default()).contentSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MayaCard_module_default()).gradientAccent,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MayaCard_module_default()).gradientBackground,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MayaCard_module_default()).textContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (MayaCard_module_default()).description,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (MayaCard_module_default()).bold,
                                                children: "Find AI-powered career advice with Maya from The Muse."
                                            }),
                                            " ",
                                            "Ask Maya anything you need to get ahead in your career\u2014from \u201CWhat can I do with an English degree?\u201D to \u201CHow can I get better at networking?\u201D"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (MayaCard_module_default()).buttonWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.themuse.com/maya",
                                            className: (MayaCard_module_default()).button,
                                            children: "Get started"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                loading: "lazy",
                src: "https://cms-assets.themuse.com/media/lead/maya-circle.jpg",
                alt: "",
                className: (MayaCard_module_default()).promoImage
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/Homepage/ContentWell.module.scss
var ContentWell_module = __webpack_require__(72);
var ContentWell_module_default = /*#__PURE__*/__webpack_require__.n(ContentWell_module);
;// CONCATENATED MODULE: ./src/Homepage/ContentWell.tsx









const LazyCoachContent = dynamic_default()(()=>__webpack_require__.e(/* import() */ 694).then(__webpack_require__.bind(__webpack_require__, 7694)).then((x)=>x.CoachContent), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7694)
            ]
    },
    ssr: false
});
const LazyAdviceContent = dynamic_default()(()=>__webpack_require__.e(/* import() */ 584).then(__webpack_require__.bind(__webpack_require__, 584)).then((x)=>x.AdviceContent), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(584)
            ]
    },
    ssr: false
});
const LazyRecentArticles = dynamic_default()(()=>__webpack_require__.e(/* import() */ 427).then(__webpack_require__.bind(__webpack_require__, 8427)).then((x)=>x.RecentArticles), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8427)
            ]
    },
    ssr: false
});
const LazyCompanyLogos = dynamic_default()(()=>__webpack_require__.e(/* import() */ 885).then(__webpack_require__.bind(__webpack_require__, 2885)).then((x)=>x.CompanyLogos), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2885)
            ]
    },
    ssr: false
});
const LazyNewsletter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 506).then(__webpack_require__.bind(__webpack_require__, 1150)).then((x)=>x.Newsletter), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1150)
            ]
    },
    ssr: false
});
const LazyTrendingSearch = dynamic_default()(()=>__webpack_require__.e(/* import() */ 908).then(__webpack_require__.bind(__webpack_require__, 908)).then((x)=>x.TrendingSearch), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(908)
            ]
    },
    ssr: false
});
const LazyCulture = dynamic_default()(()=>__webpack_require__.e(/* import() */ 408).then(__webpack_require__.bind(__webpack_require__, 4408)).then((x)=>x.Culture), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4408)
            ]
    },
    ssr: false
});
const LazyExploreCompanies = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1489)).then((x)=>x.ExploreCompanies), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1489)
            ]
    },
    ssr: false
});
const ContentWell = (props)=>{
    const { publicRuntimeConfig: { museHost  }  } = (0,config["default"])();
    const { featuredCompanies , recentArticles  } = props;
    const hasMultipleFeaturedCompanies = featuredCompanies?.featuredCompanies2?.length > 0 || featuredCompanies?.featuredCompanies3?.length > 0;
    (0,react.useEffect)(()=>{
        window.dataLayer.push({
            event: "homepageLoaded",
            page: "/",
            path: "/"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ContentWell_module_default()).contentWell,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MayaCard, {}),
            featuredCompanies && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreCompanies.ExploreCompanies, {
                featureHeading: featuredCompanies?.featuredCompaniesHeading1,
                exploreCompaniesSubheading: featuredCompanies?.exploreCompaniesSubheading,
                companies: featuredCompanies?.featuredCompanies1,
                heading: featuredCompanies?.exploreCompaniesHeading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyCulture, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyNewsletter, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyCompanyLogos, {}),
            featuredCompanies && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyExploreCompanies, {
                featureHeading: featuredCompanies?.featuredCompaniesHeading2,
                companies: featuredCompanies?.featuredCompanies2
            }),
            featuredCompanies && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyExploreCompanies, {
                featureHeading: featuredCompanies?.featuredCompaniesHeading3,
                companies: featuredCompanies?.featuredCompanies3
            }),
            hasMultipleFeaturedCompanies && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (ContentWell_module_default()).multipleCompanyButtonSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                    color: "secondary-100",
                    className: (ContentWell_module_default()).cta,
                    href: `${museHost}/companies`,
                    children: "Explore Companies"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ContentWell_module_default()).trendingSearch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyTrendingSearch, {
                    type: "trendingSearchBlock"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyAdviceContent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyRecentArticles, {
                recentArticles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyCoachContent, {})
        ]
    });
};
ContentWell.displayName = "ContentWell";


// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/Homepage/MediaVine.tsx
var MediaVine = __webpack_require__(4301);
;// CONCATENATED MODULE: ./src/pages/homepage.tsx



















const setUserCarmenData = async (setUserLocation)=>{
    try {
        const carmenResponse = await (0,api/* fetchApiCarmenData */.$3)();
        if (carmenResponse) {
            setUserLocation(JSON.stringify(carmenResponse));
        }
    } catch (error) {
        const msg = (0,errors/* getFetchError */.c)("Carmen Location", "Front-End");
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
const setUser = async (userLocation, dispatch)=>{
    try {
        const apiUser = await (0,api/* fetchUser */.BT)();
        const userData = userLocation ? {
            location: JSON.parse(userLocation)
        } : {};
        dispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: {
                ...apiUser,
                location: userData,
                isInitialized: true
            }
        });
    } catch (error) {
        dispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            logged_in: false,
            view_bookings: false,
            location: null,
            isInitialized: true
        });
        const msg = (0,errors/* getFetchError */.c)("User", "Front-End");
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
const UserInit = ({ children  })=>{
    const { user  } = (0,AppContext/* useAppState */.mr)();
    const [userLocation, setUserLocation] = (0,useSessionStorage/* default */.Z)("user_location");
    const appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    (0,react.useEffect)(()=>{
        setUser(userLocation, appDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userLocation
    ]);
    (0,react.useEffect)(()=>{
        setUserCarmenData(setUserLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(()=>{
        appDispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: {
                ...user,
                location: userLocation ? JSON.parse(userLocation) : user?.location
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userLocation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
const PageMetaInit = ({ children  })=>{
    const { pageMetaData  } = (0,AppContext/* useAppState */.mr)();
    const appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    (0,react.useEffect)(()=>{
        const { href , search  } = window.location;
        const { referrer  } = document;
        appDispatch({
            type: appContextInterfaces/* PageMetaDataActionTypes.updatePageMetaData */.e9.updatePageMetaData,
            payload: {
                ...pageMetaData,
                ...{
                    href,
                    search,
                    referrer
                }
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
const SnowPlowInit = ()=>{
    const { publicRuntimeConfig: { snowplowCollector  }  } = (0,config["default"])();
    const { user  } = (0,AppContext/* useAppState */.mr)();
    const { 0: pageViewed , 1: setPageViewed  } = (0,react.useState)(false);
    const pageData = (0,react.useMemo)(()=>({
            sp_page_is_external: false,
            sp_page_section: "homepage",
            sp_page_sponsor_id: null,
            sp_page_tab: null,
            sp_page_type: "other",
            sp_user_logged_in: user?.logged_in ?? false,
            sp_user_id: user?.id ?? 0,
            sp_experiment_experiment_id: "",
            sp_experiment_variant_id: ""
        }), [
        user
    ]);
    (0,react.useEffect)(()=>{
        if (!pageViewed) {
            // eslint-disable-next-line no-underscore-dangle
            const experimentData = {};
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ...pageData,
                ...experimentData
            });
            (0,build.initSnowplowTracker)(snowplowCollector);
            (0,build.trackSnowplowImpressions)();
            (0,build.trackSnowplowClicks)();
            (0,build.trackSnowplowModalActions)();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(()=>{
        if (user.isInitialized && !pageViewed) {
            (0,build.triggerSnowplowPageViewEvent)();
            setPageViewed(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    return null;
};
var __N_SSP = true;
const homepage_formatCompanySuggestions = (companySuggestions)=>companySuggestions.slice(0, 4).map((companyResult)=>{
        const { text , value  } = companyResult;
        const { short_name  } = value; // eslint-disable-line camelcase
        return {
            label: `${text}`,
            value: `/profiles/${short_name}` // eslint-disable-line camelcase
        };
    });
const homepage_updateInput = async (changes, setItems, setInputValue, fetchData)=>{
    const { inputValue  } = changes;
    const jobSearchItem = {
        label: `${inputValue}`,
        value: `/search/keyword/${inputValue}/`
    };
    setInputValue(inputValue);
    if (inputValue) {
        setItems([
            jobSearchItem
        ]);
        const companyResults = await fetchData(inputValue);
        const companyList = companyResults?.length ? homepage_formatCompanySuggestions(companyResults) : [];
        setItems([
            jobSearchItem
        ].concat(companyList));
    } else {
        setItems([]);
    }
};
const HomePage = (props)=>{
    const { path , featureFlags , featuredCompanies , recentArticles  } = props;
    const pageMetaData = {
        pathName: path
    };
    const { 0: dropdownItems , 1: setDropdownItems  } = (0,react.useState)([]);
    const { 0: inputValue , 1: setInputValue  } = (0,react.useState)("");
    const searchQuerySubmittedEvent = (selectedItemText)=>{
        const searchTerm = selectedItemText || inputValue;
        const eventProps = {
            search_term: searchTerm || ""
        };
        (0,tracking/* pushDataLayerEvent */.Jt)("searchQuerySubmitted", eventProps);
    };
    const onKeyboardSelectItem = (_, selectedItem)=>{
        if (!(0,browser/* isBrowser */.jU)()) return "";
        const searchPath = inputValue ? `/search/keyword/${inputValue}` : "/search";
        const selectPath = selectedItem?.value ? selectedItem?.value : searchPath;
        searchQuerySubmittedEvent(selectedItem?.label);
        return window.open(selectPath, "_blank").focus();
    };
    const onMouseSelectItem = (_, selectedItem)=>{
        searchQuerySubmittedEvent(selectedItem.label);
    };
    const dropdownProps = {
        IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
        debounceWait: 10,
        dropdownList: dropdownItems,
        inputId: "search-input",
        onInputChange: (changes)=>homepage_updateInput(changes, setDropdownItems, setInputValue, api/* fetchCompanySuggestions */.SC),
        noResultsMessage: " ",
        onKeyboardSelectItem,
        onMouseSelectItem
    };
    // A list of allowed ad types om the homepage.
    const allowList = [
        "adhesion-mobile",
        "adhesion-tablet",
        "adhesion-desktop"
    ];
    const pageLayoutProps = {
        activePath: "/",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableCompanySearch: false,
        companySearchDropdownProps: dropdownProps,
        showSubMenus: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "The Muse - Career advice and better job search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.themuse.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Find jobs at the best companies hiring near you and get free career advice."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Find jobs at the best companies hiring near you and get free career advice."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "The Muse - Career advice and better job search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }, "robots")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureFlagsContext/* FeatureFlagsProvider */.O, {
                featureFlags: featureFlags,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        id: "Organization-JSON",
                        type: "application/ld+json",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "Organization",
                                name: "The Muse",
                                url: "https://www.themuse.com/",
                                logo: "https://www.themuse.com/static/images/muse-amp-logo.jpg?v=212881e6fc388b7a61e11bb9d8ab8d0a879e4dc1a4f5ac328c41df8b0f6ee5ab",
                                sameAs: [
                                    "https://www.facebook.com/thedailymuse",
                                    "https://twitter.com/TheMuse",
                                    "https://www.instagram.com/themuse/",
                                    "https://www.youtube.com/channel/UCk4bbQAZD26f_XdGyb4wwhg",
                                    "https://www.linkedin.com/company/the-daily-muse/",
                                    "https://en.wikipedia.org/wiki/The_Muse_(website)",
                                    "https://www.pinterest.com/thedailymuse/_created/"
                                ]
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        id: "WebSite-JSON",
                        type: "application/ld+json",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org/",
                                "@type": "WebSite",
                                name: "The Muse",
                                url: "https://www.themuse.com/",
                                potentialAction: {
                                    "@type": "SearchAction",
                                    target: "https://www.themuse.com/search?keyword={search_term_string}",
                                    "query-input": "required name=search_term_string"
                                }
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, {
                        pageMetaData,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaVine/* MediaVine */.U, {
                                allowList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMetaInit, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowPlowInit, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppPageLayout/* AppPageLayout */.a, {
                                            ...pageLayoutProps,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWell, {
                                                featuredCompanies,
                                                recentArticles
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage = (HomePage);


/***/ }),

/***/ 2918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports formatNumberComma, objToQueryString, queryStringToObj, isTruthy, titleCase, normalizeAccents, parsePath, objToQueryParams, slugify, formatDate, camelToSnakeCase */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3135);

/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(" ").map(titleWordCase).join(" ");
/**
 * Converts a diacritic to normalized character plus accent. Then removes the accent.
 */ const normalizeAccents = (txt)=>txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
/**
 * Convert number to string and add a comma for thousands and millions.
 */ const formatNumberComma = (value)=>new Intl.NumberFormat("en-US").format(value);
/**
 * generate the canonical URL.
 */ const getCanonicalUrl = (asPath = "/")=>{
    const preface = "https://www.themuse.com";
    const path = asPath.split("?")[0];
    return preface + path;
};
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */ const isTruthy = (string)=>/^(true|1)$/.test(string.toLowerCase());
const parsePath = (urlPath)=>urlPath.replace(/^\/(search\/)?/, "").split("/").reduce((values, pathPart, index, shortenedPath)=>{
        const localValues = values;
        if (index % 2) {
            localValues[shortenedPath[index - 1]] = pathPart;
        } else {
            localValues[pathPart] = "";
        }
        return localValues;
    }, {});
/**
 *  Rename the object names to query param names
 */ const objToQueryParams = (obj)=>{
    const mappedObj = Object.keys(obj).reduce((acc, key)=>({
            ...acc,
            ...{
                [key]: encodeURIComponent(obj[key])
            }
        }), {});
    const queryParamStr = Object.keys(mappedObj).filter((key)=>{
        if (mappedObj[key] && mappedObj[key].length > 0) {
            return key;
        }
        return null;
    }).map((key)=>`${key}/${mappedObj[key] || ""}`).join("/");
    return queryParamStr;
};
/**
 * Convert the query string into an object
 */ const queryStringToObj = (searchString)=>{
    const pairs = searchString.split("&");
    const result = {};
    pairs.forEach((pair)=>{
        const pairSplit = pair.split("=");
        if (pairSplit[0] in result) {
            // check for additional values and add it to the result[key]
            const splitValues = result[pairSplit[0]].split(",");
            splitValues.push(decodeURIComponent(pairSplit[1]));
            result[pairSplit[0]] = splitValues.join(",");
        } else {
            result[pairSplit[0]] = decodeURIComponent(pairSplit[1] || "");
        }
    });
    return result;
};
/**
 * Convert an object to query string removing nulls.
 */ const objToQueryString = (obj)=>Object.keys(obj).map((key)=>`${key}=${obj[key] || ""}`).join("&");
/**
 * Remove special characters and reduce to lower case with hyphens.
 */ const slugify = (text)=>decodeURIComponent(text).replace(/[^a-z0-9]/gmi, "-").replace(/--/gmi, "-").toLowerCase();
/**
 * Formats a date in correct format for job card
 */ const formatDate = (date)=>{
    const month = months[date.getMonth()];
    const day = date.getDate();
    return `${month} ${day}`;
};
function camelToSnakeCase(text) {
    return text.replace(/(.)([A-Z][a-z]+)/, "$1_$2").replace(/([a-z0-9])([A-Z])/, "$1_$2").toLowerCase();
}
/**
 * Converts an id number to a string
 */ const getId = (id)=>id ? parseInt(id, 10) : undefined;



/***/ }),

/***/ 2188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animationContainer":"AnimationContainer_animationContainer__1Wg6t","animation":"AnimationContainer_animation__CTauG","fade-in-up":"AnimationContainer_fade-in-up__KLr5f","animationContainerChildren":"AnimationContainer_animationContainerChildren__VJ4f2"};

/***/ }),

/***/ 5264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"companyCard":"CompanyCard_companyCard__w8END","header":"CompanyCard_header__7cgCy","hero":"CompanyCard_hero__4VIfM","logo":"CompanyCard_logo__Zd2b2","content":"CompanyCard_content__WKVAx","name":"CompanyCard_name__nsEsn","description":"CompanyCard_description__8bREJ","footer":"CompanyCard_footer__nRxQh","search":"CompanyCard_search__0Y6Y4","profile":"CompanyCard_profile__Xun1L"};

/***/ }),

/***/ 72:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentWell":"ContentWell_contentWell__x5xsY","trendingSearch":"ContentWell_trendingSearch__WeHyQ","multipleCompanyButtonSection":"ContentWell_multipleCompanyButtonSection__gJCxj","cta":"ContentWell_cta__iAAxt"};

/***/ }),

/***/ 5579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"ExploreCompanies_section__gjIbw","heading":"ExploreCompanies_heading__bQvV6","subheading":"ExploreCompanies_subheading___cbpi","grid":"ExploreCompanies_grid__Z_HRI","sectionTitle":"ExploreCompanies_sectionTitle__X5NW7"};

/***/ }),

/***/ 4020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"HomepageHeader_headerContainer__O0m7X","left":"HomepageHeader_left__2XWAC","h1":"HomepageHeader_h1__nSpGB","subtext":"HomepageHeader_subtext__35AmD","right":"HomepageHeader_right__qdnwi","hero":"HomepageHeader_hero__pcx8t","images":"HomepageHeader_images__pRAi3","stars":"HomepageHeader_stars__VueUC"};

/***/ }),

/***/ 5572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchDropdown_container__ayqYo","containerOpened":"SearchDropdown_containerOpened__uFZN3 SearchDropdown_container__ayqYo","inputContainer":"SearchDropdown_inputContainer__pqO3C","inputContainerOpened":"SearchDropdown_inputContainerOpened__6h2oS SearchDropdown_inputContainer__pqO3C","input":"SearchDropdown_input__Puwp5","menuOpened":"SearchDropdown_menuOpened__e6ziq","inputClearButton":"SearchDropdown_inputClearButton__7sPY6","closeButton":"SearchDropdown_closeButton__Bn5Nk","menuList":"SearchDropdown_menuList__hVpFS","listItem":"SearchDropdown_listItem__Xng5r","listItemText":"SearchDropdown_listItemText__PQTxa","postLabel":"SearchDropdown_postLabel__LmQAq"};

/***/ }),

/***/ 2909:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mayaPromo":"MayaCard_mayaPromo__V9s0C","contentWrapper":"MayaCard_contentWrapper__ZdyVw","logo":"MayaCard_logo__Bw7NG","contentSection":"MayaCard_contentSection__78ES8","gradientAccent":"MayaCard_gradientAccent__6ZC6d","gradientBackground":"MayaCard_gradientBackground__34k4e","textContent":"MayaCard_textContent__my8e7","description":"MayaCard_description__iQWc4","bold":"MayaCard_bold__rzqVd","button":"MayaCard_button__yBbgG","promoImage":"MayaCard_promoImage__l3SLQ"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","pageHeader":"Home_pageHeader__Y8w6l","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [734,551,850,190,774,888,179], function() { return __webpack_exec__(9497); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);